var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.86,12v3.54a1.4,1.4,0,0,1-1.4,1.4H1.9a1.4,1.4,0,0,1-1.4-1.4V4a1.4,1.4,0,0,1,1.4-1.4H5.29","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M15.67,3.82a8.29,8.29,0,0,0-4.44.35c-4.38,1.38-3.55,6.38-3.55,6.38","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M12.77.5l3.54,3.33L12.77,7.09","fill":"none","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Share.defaultProps = {"viewBox":"0 0 16.81 17.41"};

module.exports = Share;

Share.default = Share;
